import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { fetchLegalPageContent } from "../api/aboutusApi";
import ContentSkeleton from "./ContentSkeleton";
import Footer from "./Footer";
import Header from "./header";
import Subbanner from "./Subbanner";
import { useTranslation } from "react-i18next";

// Dynamic slug-to-key mapping
const slugMap: Record<string, string> = {
  about: "about-us",
  terms: "terms",
  pp: "privacy-policy",
};

// Keys for i18n titles
const titleMap: Record<string, string> = {
  about: "legal.about",
  terms: "legal.terms",
  pp: "legal.privacy",
};

const PrivacyPolicy: React.FC = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type") || "";

  const { t } = useTranslation();
  const [htmlContent, setHtmlContent] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);

  const slug: string = slugMap[type] || "privacy-policy";
  const titleKey: string = titleMap[type] || "legal.privacy";

  useEffect(() => {
    setLoading(true);
    fetchLegalPageContent(slug).then((html: string | undefined) => {
      if (html) setHtmlContent(html);
      setLoading(false);
    });
  }, [slug]);

  return (
    <div className="w-full h-full">
      <Header />
      <Subbanner />
      <div className="bg-white px-4 py-10 max-w-5xl mb-10 mx-auto text-[#070B28] font-proxima">
        {loading ? (
          <ContentSkeleton />
        ) : (
          <>
            <h1 className="text-3xl font-bold mb-6">{t(titleKey)}</h1>
            <div
              className="text-base leading-relaxed"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            ></div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
